const paymentConst = {
  paymentState: {
    initial: "initial",
    pendingToken: "pending_token",
    pendingSecure3d: "pending_3ds",
    pendingBackendSubmission: "pending_backend_submission",
    decline: "decline",
    success: "success",
    addingCard: "adding_card",
    addCardSaved: "card_saved",
    addCardFailed: "card_failed",
  },
  xenopayPaymentStatus: {
    successful: "successful",
  },
  alphapoPaymentStatus: {
    successful: "successful",
    failed: "failed",
    pendingPayment: "pending_payment",
  },
  genesisPaymentStatus: {
    successful: "successful",
    failed: "failed",
    pendingPayment: "pending_payment",
  }
};

export default paymentConst;
